// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"cec6abc4","983":"1091917a"}[chunkId] + ".chunk.js";
};